/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* istanbul ignore file */
import * as Survey from "survey-react";
import { PersonRequest } from "@plinknz/tah-website-elements";

import { APPLIED_STATUS, GrantPayload } from "../../config/forms";
import { createSVGNew } from "../svg/svg";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { collapseSurrogate } from "../../service/forms/config-generics/personal-details";

export function transformBenefitFormData(
  survey: Survey.ReactSurveyModel,
  member: PersonRequest,
  config: { pages: PageConfig[] },
  type: string
): GrantPayload {
  const now = new Date().getTime();
  const tenant = process.env.TAH_TENANT;
  const surveyData = survey.data;
  const data = collapseSurrogate(surveyData);
  const { svg: interaction, text } = createSVGNew({
    heading: `${type} Application`,
    data: {
      ...survey.data,
      member,
    },
    config,
  });

  const payloadData: GrantPayload = {
    data: {
      interaction: {
        interaction,
        interactionDate: now,
      },
      email: {
        name: `${data.firstName} ${data.surname}`,
        email: data.email,
        message: text,
      },
    },
    targetId: survey.data.id || member.id,
    recaptcha: null,
    tenant,
  };

  if (type.match("Grant") || type.match("Scholarship")) {
    payloadData.data.benefit = {
      benefitDescription: type,
      benefitStatus: APPLIED_STATUS,
      benefitDate: now,
    };
  } else {
    payloadData.data.event = {
      eventDescription: type,
      eventDate: now,
    };
  }

  return payloadData;
}
